<template>
  <FormViewBase title="Verify Your Email">
    <template #default>
      <v-row class="text-h6 py-5"
        ><v-col cols="12">
          You should receive an email with a verification link in the next few
          minutes. If you don't see it, please check your spam folders or use
          the button below to send the email again.
        </v-col></v-row
      >
    </template>
    <template #errors>
      <v-alert v-if="!!error" type="warning" text>
        {{ error }}
      </v-alert>
    </template>
    <template #actions>
      <transition name="fade" mode="out-in">
        <v-alert v-if="success" text type="success" dense
          >Verification Email Sent!</v-alert
        >
        <v-btn
          v-else
          color="blue darken-3"
          class="white--text mb-4"
          depressed
          large
          block
          :loading="working"
          :disabled="working"
          @click="resendHandler"
          >Resend Verification Email</v-btn
        >
      </transition>
    </template>
  </FormViewBase>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapFields } from 'vuex-map-fields'
import { mapActions, mapGetters } from 'vuex'
import _get from 'lodash/get'
import RouteNames from '@/constants/RouteNames'
import FormViewBase from '@/views/FormViewBase'
export default {
  name: 'EmailVerificationView',
  components: { FormViewBase },
  created() {
    if (this.isAuthUserEmailVerified) {
      this.$router.push({ name: RouteNames.Customer.ORDERS_INDEX })
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthUserEmailVerified']),
    ...mapFields('snackbars', ['showEmailVerifiedSnackbar']),
  },
  methods: {
    ...mapActions('auth', ['sendVerificationEmail']),
    async resendHandler() {
      this.working = true
      this.success = false
      try {
        await this.sendVerificationEmail()
        this.success = true
      } catch (error) {
        Sentry.captureException(error)
        this.error = _get(
          error,
          'response.data.error.message',
          'We were unable to send the verification email. If you continue to see this error please contact support at hi@getminimart.com'
        )
      } finally {
        this.working = false
      }
    }, // resendHandler
  },
  data() {
    return {
      working: false,
      success: false,
      error: false,
    }
  },
}
</script>
